module.exports = __webpack_public_path__ + "35a025bccb92ffe274ff83c92d9290e2.MP3";